import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';
import ThroughputChart from './ThroughputChart';
import ExactThroughput from './ExactThroughput';
import ThroughputBreakdown from './ThroughputBreakdown';

import '../Throughput.scss';

class WallboardThroughputChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Throughput Run Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="trc" showLineChart showBreakdown options={{ lineChartTooltip: 'Throughput' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          <DetailsAccordion
            dateLabel="Date"
            valueLabel="Throughput"
            value2Label="Cycle time"
            id="details-accordion"
            data={this.state.selectedPoint}
          />
          {!!this.props.data.length && this.props.lineChart && (
            <ExactThroughput data={this.props.data} dateFormat={this.props.dateFormat} />
          )}
          {!!this.props.data.length && this.props.breakdown && (
            <ThroughputBreakdown id="throughput-breakdown" data={this.props.data} />
          )}
        </div>
        <div className="diagram_details">
          <ThroughputChart id="Throughput" data={this.props.data} onPointClick={this.handlePointClick} />
          <NoData show={!this.props.data.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    breakdown: state.filters.trc.breakdown,
    dateFormat: state.filters.dateFormat,
    lineChart: state.filters.trc.lineChart,
    data: state.throughput.data,
    isLoading: state.throughput.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardThroughputChart);
